import { useState } from 'react'
import 'date-fns'
import { format } from 'date-fns'
import DateFnsUtils from '@date-io/date-fns'
import { useForm } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'
import * as yup from 'yup'
import {
  Dialog,
  DialogContent,
  TextField,
  DialogActions,
  Button,
  CircularProgress,
} from '@material-ui/core'
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from '@material-ui/pickers'
import { makeStyles } from '@material-ui/core'

import { IPBTransactionAddProps } from '../types'

const useStyles = makeStyles({
  field: {
    paddingBottom: 15,
  },
  actions: {
    justifyContent: 'flex-end',
    marginRight: 10,
  },
})

const schema = yup
  .object({
    amount: yup.number().min(0).required(),
    comment: yup.string().required(),
  })
  .required()

export const PBTransactionAdd = (props: {
  id: string
  isOpen: boolean
  setOpen: (v: boolean) => void
  billingCycleId: number
  isLoading: boolean
  handleAdd: (v: IPBTransactionAddProps) => void
}) => {
  const { id, isOpen, setOpen, billingCycleId, isLoading, handleAdd } = props

  const classes = useStyles()

  const {
    register,
    handleSubmit,
    watch,
    setValue,
    clearErrors,
    formState: { errors },
  } = useForm({ resolver: yupResolver(schema) })

  const [scheduledDate, setScheduledDate] = useState<Date | null>(null)

  const buildData = (): IPBTransactionAddProps => {
    const data: IPBTransactionAddProps = {
      userId: parseInt(id),
      source: 'Depository',
      scheduledDate: format(scheduledDate!, 'yyyy-MM-dd'),
      comment: watch('comment'),
      amount: parseInt(watch('amount')),
      billingCycleId: billingCycleId,
    }

    return data
  }

  const handleClose = () => {
    clearErrors()
    setOpen(false)
    setScheduledDate(null)
    setValue('comment', '')
    setValue('amount', '')
  }

  return (
    <>
      <Dialog
        open={isOpen}
        onClose={handleClose}
        aria-labelledby="draggable-dialog-title"
      >
        <DialogContent>
          <TextField
            error={errors.amount !== undefined}
            helperText={errors.amount?.message}
            className={classes.field}
            label="Amount"
            fullWidth
            {...register('amount')}
          />
          <TextField
            error={errors.comment !== undefined}
            helperText={errors.amount?.message}
            label="comment"
            type="text"
            fullWidth
            {...register('comment')}
          />
          <MuiPickersUtilsProvider utils={DateFnsUtils}>
            <KeyboardDatePicker
              minDate={Date.now()}
              margin="normal"
              id="date-picker-dialog"
              label="Scheduled date"
              format="yyyy/MM/dd"
              value={scheduledDate}
              onChange={setScheduledDate}
              KeyboardButtonProps={{
                'aria-label': 'change date',
              }}
            />
          </MuiPickersUtilsProvider>
        </DialogContent>
        <DialogActions className={classes.actions}>
          <Button onClick={handleClose} color="primary" variant="outlined" disabled={isLoading}>
            Cancel
          </Button>
          <Button
            onClick={handleSubmit(() => handleAdd(buildData()))}
            color="primary"
            variant="contained"
            style={{ marginLeft: 15 }}
            disabled={isLoading || scheduledDate === null}
            startIcon={isLoading && <CircularProgress size={14} color='inherit' />}
          >
            Save
          </Button>
        </DialogActions>
      </Dialog>
    </>
  )
}
